/**
 * Sponsors Carousel Block JavaScript
 *
 * Provides carousel functionality for the sponsors carousel block using Accessible Slick Slider
 */

import $ from 'jQuery';

export default function (enableDebug = false) {
	initCarousel();

	function initCarousel() {
		if (enableDebug) console.log('Sponsors Carousel initialization started');
		const $carousels = $('.sponsors-carousel__slider');

		if ($carousels.length === 0) {
			if (enableDebug) console.warn('No sponsors carousel found with class .sponsors-carousel__slider');
			return;
		}

		if (enableDebug) console.log('Found', $carousels.length, 'carousel containers');

		$carousels.each(function () {
			const $carousel = $(this);
			const $block = $carousel.closest('.sponsors-carousel');

			if (enableDebug) {
				console.log('Processing carousel:', $carousel);
				console.log('Number of slides:', $carousel.find('.sponsors-carousel__slide').length);
			}

			const $navigation = $block.find('.carousel-navigation');
			const $prevArrow = $navigation.find('.arrow--prev');
			const $nextArrow = $navigation.find('.arrow--next');
			const $pagination = $navigation.find('.carousel-pagination');

			if (enableDebug) {
				console.log('Found custom navigation:', $navigation.length > 0);
				console.log('Found prev arrow:', $prevArrow.length > 0);
				console.log('Found next arrow:', $nextArrow.length > 0);
				console.log('Found pagination container:', $pagination.length > 0);
			}

			if (typeof $.fn.slick === 'undefined') {
				if (enableDebug) console.error('Slick library is not available!');
				return;
			}

			if (enableDebug) console.log('Slick is available, initializing carousel');

			try {
				if ($carousel.hasClass('slick-initialized')) {
					if (enableDebug) console.log('Carousel already initialized, destroying first');
					$carousel.slick('unslick');
				}

				const slideCount = $carousel.find('.sponsors-carousel__slide').length;
				const slidesToShow = $(this).parents('.page-sidebar-navigation__content').length ? Math.min(slideCount, 4) : Math.min(slideCount, 6);
				const slidesToShowFourteenHundred = $(this).parents('.page-sidebar-navigation__content').length ? Math.min(slideCount, 4) : Math.min(slideCount, 5);
				const slidesToShowElevenHundred = $(this).parents('.page-sidebar-navigation__content').length ? Math.min(slideCount, 3) : Math.min(slideCount, 5);
				const slidesToShowTenTwentyFour = $(this).parents('.page-sidebar-navigation__content').length ? Math.min(slideCount, 3) : Math.min(slideCount, 4);

				if (enableDebug) console.log(`Setting slidesToShow to ${slidesToShow} based on ${slideCount} slides`);

				$carousel.find('.sponsors-carousel__slide').css('display', 'flex');
				$carousel[0].offsetHeight;

				if (enableDebug) console.log('Preparing to initialize Slick with', slidesToShow, 'slides visible');

				$carousel.slick({
					slidesToShow: slidesToShow,
					slidesToScroll: slidesToShow,
					arrows: true,
					dots: true,
					infinite: true,
					autoplay: false,
					speed: 500,
					adaptiveHeight: false,
					cssEase: 'linear',
					centerMode: false,
					variableWidth: false,
					dotsClass: 'carousel-pagination',
					prevArrow: $prevArrow,
					nextArrow: $nextArrow,
					appendDots: $pagination,
					customPaging: function () {
						return '<button class="carouse-pagination__page"></button>';
					},
					responsive: [
						{
							breakpoint: 1400,
							settings: {
									slidesToShow: slidesToShowFourteenHundred,
									slidesToScroll: slidesToShowFourteenHundred
							}
						},
						{
							breakpoint: 1100,
							settings: {
									slidesToShow: slidesToShowElevenHundred,
									slidesToScroll: slidesToShowElevenHundred
							}
						},
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: slidesToShowTenTwentyFour,
								slidesToScroll: slidesToShowTenTwentyFour
							 }
						},
						{
							breakpoint: 850,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 4
							 }
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 3
							}
						},
						{
							breakpoint: 570,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							}
						}
					]
				});

				if (enableDebug) console.log('Slider initialized successfully');

				if (!window.slickCarousels) window.slickCarousels = [];
				window.slickCarousels.push($carousel);

				setTimeout(() => {
					if ($carousel.hasClass('slick-initialized')) {
						if (enableDebug) console.log('Slick initialization confirmed via class');

						$pagination.find('button').first().addClass('is-active');

						$carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
							const slidesToShow = slick.options.slidesToShow;
							const totalPages = Math.ceil(slick.slideCount / slidesToShow);
							let nextPage = Math.floor(nextSlide / slidesToShow);

							// If nextSlide exceeds the maximum starting index, set to last page.
							if (nextPage >= totalPages) {
								nextPage = totalPages - 1;
							}

							$pagination.find('button').removeClass('is-active');
							$pagination.find('button').eq(nextPage).addClass('is-active');
						});

						$carousel.on('afterChange', function (event, slick, currentSlide) {
							const slidesToShow = slick.options.slidesToShow;
							const totalSlides = slick.slideCount;

							$prevArrow.prop('disabled', currentSlide === 0);
							// Disable next arrow if we're at or past the last full (or partial) page.
							$nextArrow.prop('disabled', currentSlide >= totalSlides - slidesToShow);
						});
					} else {
						if (enableDebug) console.warn('Slick initialization may have failed - missing slick-initialized class');
					}

					if (enableDebug) {
						console.log('Carousel container:', $carousel[0]);
						console.log('Carousel track:', $carousel.find('.slick-track')[0]);
						console.log('Carousel slides:', $carousel.find('.slick-slide').length);
					}
				}, 500);
			} catch (error) {
				if (enableDebug) console.error('Error initializing slick slider:', error);
			}
		});
	}
}
